/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    UPDATE_BILLING_ADDRESS_IN_CART,
    UPDATE_BILLING_ADDRESS_IN_CART_SUCCESS,
    UPDATE_BILLING_ADDRESS_IN_CART_FAILED,
    UPDATE_BILLING_ADDRESS_IN_ADDRESS_BOOK,
    UPDATE_BILLING_ADDRESS_FORM,
    UPDATE_BILLING_ADDRESS_FORM_BY_NAME,
    BILLING_ADDRESS_CLEAR_FORM,
    BILLING_ADDRESS_IS_FORM_VALID,
    BILLING_ADDRESS_IS_FORM_AUTO_FILLED,
    BILLING_ADDRESS_SET_AS_DEFAULT,
    BILLING_ADDRESS_CHECK_SAME_AS_DELIVERY_ADDRESS,
} from './BillingAddress-ActionTypes';

export const updateBillingAddress = (data, history, page = '') => ({
    type: UPDATE_BILLING_ADDRESS_IN_CART,
    payload: {
        data,
        history,
        page,
    },
});

export const updateBillingAddressSuccess = () => ({
    type: UPDATE_BILLING_ADDRESS_IN_CART_SUCCESS,
});

export const updateBillingAddressFailed = (exception) => ({
    type: UPDATE_BILLING_ADDRESS_IN_CART_FAILED,
    payload: exception,
});

export const updateBillingAddressInAddressBook = () => ({
    type: UPDATE_BILLING_ADDRESS_IN_ADDRESS_BOOK,
});

export const updateBillingAddressForm = (data) => ({
    type: UPDATE_BILLING_ADDRESS_FORM,
    data,
});

export const updateBillingAddressFormByName = (event) => ({
    type: UPDATE_BILLING_ADDRESS_FORM_BY_NAME,
    data: event,
});

export const billingAddressClearForm = () => ({
    type: BILLING_ADDRESS_CLEAR_FORM,
});

export const billingAddressIsFormValid = (data) => ({
    type: BILLING_ADDRESS_IS_FORM_VALID,
    data,
});

export const billingAddressIsFormAutoFilled = (data) => ({
    type: BILLING_ADDRESS_IS_FORM_AUTO_FILLED,
    data,
});

export const billingAddressSetAsDefault = (data) => ({
    type: BILLING_ADDRESS_SET_AS_DEFAULT,
    data,
});

export const billingAddressCheckSameAsDeliveryAddress = (data) => ({
    type: BILLING_ADDRESS_CHECK_SAME_AS_DELIVERY_ADDRESS,
    data,
});
